module.exports = __webpack_public_path__ + "static/img/6.b4e70a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/6.jpg
// module id = Guyu
// module chunks = 1